import React, { useContext, useEffect, useState } from "react";
import { Button } from "../core/views/Button";
import { Title } from "../core/views/Title";
import { LoginBox } from "./LoginBox";
import { Spin } from "../core/views/Spin";
import { GlobalContext } from "../GlobalContext";
import { UserInfo } from "../core/api/contracts/User";
import { useHistory, useParams } from "react-router";

export function VerifyEmailView() {
  const context = useContext(GlobalContext);
  const [status, setStatus] = useState<{ loading: boolean; error?: boolean; user?: UserInfo }>({ loading: true });
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  useEffect(() => {
    context.api
      .verify(id, () => {
        setStatus({ loading: false, error: true });
      })
      .then((user: UserInfo) => {
        if (user) {
          setStatus({ loading: false, user });
        }
      });
  }, [id]);

  const handleContinue = () => {
    if (!status.loading) {
      history.push("/login");
    }
  };

  const { loading, error, user } = status;

  return (
    <LoginBox>
      <h1>
        {loading
          ? "Verifying your email address"
          : error
          ? "Error while verifying email address"
          : "Email Verification Completed Successfully"}
      </h1>

      <div className="create-feature-form">
        <Spin spinning={loading}>
          {!loading && (
            <>
              {error ? (
                <p>Could not verify email address. Please contact support.</p>
              ) : (
                <p>
                  Hi{" "}
                  <strong>
                    <Title text={user.name} />
                  </strong>{" "}
                  ({user.email}), thanks for verifying your email address.
                </p>
              )}
            </>
          )}
        </Spin>
        <Button type="primary" onClick={handleContinue} loading={loading}>
          Continue
        </Button>
      </div>
    </LoginBox>
  );
}
